"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableArea = require("./TableArea");

var _TableArea2 = _interopRequireDefault(_TableArea);

var _Column = require("./Column");

var _Column2 = _interopRequireDefault(_Column);

var _Toolbar = require("./Toolbar");

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _ToolbarBatch = require("./ToolbarBatch");

var _ToolbarBatch2 = _interopRequireDefault(_ToolbarBatch);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _locale = require("./locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableAreaWithLocale = (0, _localeProvider2.default)(_TableArea2.default);
TableAreaWithLocale.LOCALE = _locale2.default;

TableAreaWithLocale.Column = _Column2.default;
TableAreaWithLocale.Toolbar = _Toolbar2.default;
TableAreaWithLocale.ToolbarBatch = _ToolbarBatch2.default;

exports.default = TableAreaWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/index.js
// module id = 705
// module chunks = 0